'sue client'
import { Delete, Done, MailLock, Search } from "@mui/icons-material";
import React, {
  forwardRef,
  useContext,
  // useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import UsableTable from "@/app/reusableComponents/UsableTable";
// import { UniversityData, headerCells } from "../../services/admin/UniversityDataNew";
// import urlImage from '../../http-common-images';
// import { Link } from "react-router-dom";
import useStylesSearchTable from "@/app/reusableComponents/SearchTableStyle";
import { Avatar, Button, Grid, InputAdornment } from "@mui/material";
import { useIntl } from "react-intl";
// import StudentEdit from "./StudentEdit";
// import StudentpromotionShowEdit from "./StudentpromotionShowEdit";
import { getAllMensagemenvoyes, getAllMensagemenvoyesByMainID, getAllNotificacaoRecus, getAllNotifications } from "@/app/services/admin/NotificacoesUsuario.services";
import MailIcon from "@mui/icons-material/Mail";
import DraftsIcon from "@mui/icons-material/Drafts";

// import CycleData from 'services/admin/CycleData';
import  Link  from 'next/link';

import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators";
import { useTheme } from "@mui/material/styles";
import { useRouter } from 'next/navigation';

import DOMPurify from 'dompurify';

const NotificationAuxEtudiantsSearchTable = forwardRef((props, ref) => {
  // forwardRef is used to update method from this file from ather files

  const intl = useIntl();

  // const [openPopup, setOpenPopup] = useState(false);

  const {
    idDisplay,
    dataDisplay,
    horaDisplay,
    tituloDisplay,
    mensagemDisplay,
    lidaDisplay,
    actionsButtonDisplayEditDelete,
    pageSize,
    rowPerPage,
    universityID,
    studentMatriculaID,
    userNameDisplay,
    userPhotoDisplay,
    dadosTable,
    messageRecuEnvoye,
    handleDrawerOpen,
    readMessageSentToStudents
  } = props;

  const [notificationTable, setNotificationTable] = useState([]);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [fieldToSeach, setFieldToSeach] = useState("");
  const [dataToSearch, setDataToSearch] = useState("");

  // const [firstNameSearch, setFirstNameSearch] = useState("");
  const [openPopupEdit, setOpenPopupEdit] = useState(false);
  const [openPopupEditPromotion, setOpenPopupEditPromotion] = useState(false);

  const [dataEdit, setDataEdit] = useState([{}]);
  const [open, setOpen] = useState(false);

  const [numeroetudiant, setNumeroetudiant] = useState("");
  const [userID, setUserID] = useState("");
  const [data, setData] = useState("");
  const [hora, setHora] = useState("");
  const [typeMessage, setTypeMessage] = useState("");
  const [url, setUrl] = useState(getBaseURL());  // backend URL

  const [notificacao, setnotificacao] = useState([]);

  const [messageExpediteur, setmessageExpediteur] = useState(2);
  const router = useRouter();


  const propsTableGrid = {
    // grid style: SearchTableStyle.js
    backGroundColor: props.backGroundColor,
    color: props.color,
    fontSize: props.fontSize,
  };

  const classes = useStylesSearchTable(propsTableGrid);
  // const { notificacao, messageExpediteur } = useSelector((state) => state.notificacaoUsuarios2);

  const theme = useTheme();
  const textColor = theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary;


  useEffect(() => {
    getTime();
    // getNotifications(universityID, studentMatriculaID);
  }, [notificacao]);
  //  }, [notificacao, messageExpediteur]);


  const getTime = () => {
    let today = new Date();
    setHora(
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
    );
    let today2 = new Date().toLocaleDateString();
    setData(today2);
  };

  useImperativeHandle(ref, () => ({
    // getFirstnameSearch: getFirstnameSearch,
    getNotifications: getNotifications, // it's calling the method : unversityGetAll()
    getMensagensEnvoyeall: getMensagensEnvoyeall, // it's calling the method : unversityGetAll()

  }));

  
  const getNotifications = (universityID1, userID, type) => {
    setTypeMessage(type);
   
    if (universityID1 > 0) {
      getAllMensagemenvoyes("messages_aux_administratifs_Recu_all", universityID, userID, 2)
        .then((response) => {
          setnotificacao(response.data);

        })
        .catch((e) => {
          console.log(e);
        });
    }
  };


  const getMensagensEnvoyeall = (mainID) => {
       
    
    if (mainID > 0) {

      getAllMensagemenvoyesByMainID("mensagensEnvoyesAll", mainID)
        .then((response) => {
          setnotificacao(response.data);

        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const handleNavigation = (params) => {
    readMessageSentToStudents(
      params
    );

    const queryParams = new URLSearchParams({
      id: params.row.id,
      messageRecuEnvoye: messageRecuEnvoye,
      handleDrawerOpen: handleDrawerOpen,
      paramTable: JSON.stringify(params.row), // Make sure to stringify any object
    
    }).toString();

   //  router.push(`/mail-read?${queryParams}`);
  };

  
  const columns = [
    idDisplay
      ? {
          field: "id",
          headerName: "ID",
          flex: 1,
          headerClassName: classes.gridHeader,
        }
      : {
          field: "id",
          headerName: "ID",
          flex: 1,
          hide: { idDisplay },
          headerClassName: classes.gridHeader,
        },
  
    userPhotoDisplay
      ? {
          field: "photo",
          headerName: "",
          flex: 0.5,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <>
                {Number(params.row.group_beneficiaire) < 6 ? (
                  <Avatar
                    alt=""
                    src={
                      params.row?.photofilename !== ""
                        ? url + `/studentMatriculas/images?tipoDisplay=${params.row.photofilename}`
                        : url + "/studentMatriculas/images?tipoDisplay=semfoto.png"
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    onClick={() => handleNavigation(params)} // Trigger navigation on click
                  />
                ) : (
                  <Avatar
                    alt=""
                    src={
                      params.row.notificacoesUsuariosUser &&
                      params.row.photofilename !== ""
                        ? url + `/users/images?tipoDisplay=${params.row.photofilename}`
                        : url + "/users/images?tipoDisplay=semfoto.png"
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    onClick={() => handleNavigation(params)} // Trigger navigation on click
                  />
                )}
              </>
            );
          },
        }
      : {
          field: "photo",
          headerName: "photo",
          flex: 2,
          hide: { userPhotoDisplay },
          headerClassName: classes.gridHeader,
        },
  
    userNameDisplay
      ? {
          field: "expediteur",
          headerName: intl.formatMessage({ id: "destinataire" }),
          flex: 2.2,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <span
                style={{ fontSize: "12px", color: textColor, cursor: "pointer" }}
                onClick={() => handleNavigation(params)}
              >
                {Number(params.row.group_beneficiaire) < 6
                  ? params.row.firstname && params.row.lastname
                    ? params.row.firstname + " " + params.row.lastname
                    : "No student information available"
                  : params.row.firstname && params.row.lastname
                  ? params.row.firstname + " " + params.row.lastname
                  : "No admin information available"}
              </span>
            );
          },
        }
      : {
          field: "expediteur",
          headerName: "expediteur",
          flex: 1,
          hide: { userNameDisplay },
          headerClassName: classes.gridHeader,
        },
  
    {
      field: "data",
      headerName: intl.formatMessage({ id: "data" }),
      flex: 1,
      headerClassName: classes.gridHeader,
      renderCell: (params) => {
        const formattedDate = new Date(params.row.data).toLocaleDateString("en-GB");
  
        return (
          <span
            style={{ fontSize: "12px", color: textColor, cursor: "pointer" }}
            onClick={() => handleNavigation(params)}
          >
            {formattedDate}
          </span>
        );
      },
    },
  
    horaDisplay
      ? {
          field: "hora",
          headerName: intl.formatMessage({ id: "hora" }),
          flex: 1,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <span
                style={{ fontSize: "12px", color: textColor, cursor: "pointer" }}
                onClick={() => handleNavigation(params)}
              >
                {params.row.hora}
              </span>
            );
          },
        }
      : {
          field: "hora",
          headerName: "hora",
          flex: 1,
          hide: { horaDisplay },
          headerClassName: classes.gridHeader,
        },
  
    tituloDisplay
      ? {
          field: "titulo",
          headerName: intl.formatMessage({ id: "titulo" }),
          flex: 2,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <span
                style={{ fontSize: "12px", color: textColor, cursor: "pointer" }}
                onClick={() => handleNavigation(params)}
              >
                {params.row.titulo.replace("<p>", "").replace("</p>", "")}
              </span>
            );
          },
        }
      : {
          field: "titulo",
          headerName: "titulo",
          flex: 1,
          hide: { tituloDisplay },
          headerClassName: classes.gridHeader,
        },
  
        {
          field: "mensagem",
          headerName: intl.formatMessage({ id: "mensagem" }),
          flex: 3,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            // Sanitize the HTML content
            const sanitizedHtml = DOMPurify.sanitize(params.row.mensagem);
      
            return (
              <span
                style={{ fontSize: "12px", color: textColor, cursor: "pointer" }}
                onClick={() => handleNavigation(params)}
                dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
              />
            );
          },
    },
  
    lidaDisplay
      ? {
          field: "lida",
          headerName: intl.formatMessage({ id: "lida" }),
          flex: 0.4,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <span onClick={() => handleNavigation(params)}>
                {Number(params.row.lida) === 1 ? (
                  <MailIcon style={{ color: "red" }} />
                ) : (
                  <DraftsIcon style={{ color: "green" }} />
                )}
              </span>
            );
          },
        }
      : {
          field: "lida",
          headerName: "lida",
          flex: 1,
          hide: { lidaDisplay },
          headerClassName: classes.gridHeader,
        },
  
    actionsButtonDisplayEditDelete
      ? {
          field: "action5",
          headerName: intl.formatMessage({ id: "action" }),
          flex: 1,
          headerClassName: classes.gridHeader,
          renderCell: (params) => {
            return (
              <Delete
                className={classes.deleteSearchButton}
                onClick={() => {
                  getTime();
                  // handleDelete(params.row.id, params.row.nomEcole, params.row.clycleID, params.row.studentMatriculaID);
                }}
              />
            );
          },
        }
      : {
          field: "action5",
          headerName: "Action",
          flex: 1,
          hide: { actionsButtonDisplayEditDelete },
          headerClassName: classes.gridHeader,
        },
  ];
  
  

  return (
    <>
      {/* {openPopupEdit ? (
        <Grid item xs={12} sx={{ textAlign: "right" }}>
          <EcoleProvenanceEdit
            dataEdit={dataEdit}
            open={open}
            handleCloseDialog={handleCloseDialog}
          />
        </Grid>
      ) : null} */}

      <UsableTable
        records={notificacao}
        columns={columns}
        pageSize={pageSize}
        rowPerPage={rowPerPage}
        campoPesquisa={fieldToSeach}
        firstNameSearch={dataToSearch}
      />
    </>
  );
});

export default NotificationAuxEtudiantsSearchTable;
